var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "30px",
    viewBox: "0 0 82 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "For-You",
    transform: "translate(-56.000000, -22.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(56.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9645539,10.1435095 C39.6783553,3.70263108 42.8803766,0.0874283784 48.0243411,0.0874283784 C53.6131709,0.0874283784 56.5120787,3.80236081 56.5120787,9.37060405 L56.528327,24.0829554 L50.2850858,24.0142527 L50.2850858,11.2322257 C50.2850858,7.39263108 48.7555113,5.02405 44.6536745,5.02405 C41.0067879,5.02405 39.199873,7.50898243 38.9645539,11.1491176 L32.7117879,14.6313473 C32.0220787,20.9974284 29.0391284,24.6458743 23.9455894,24.6458743 C18.3573199,24.6458743 15.4158305,20.9309419 15.4158305,15.3626986 L15.4158305,0.552833784 L21.6433837,0.552833784 L21.6433837,13.5093878 C21.6433837,17.3489824 23.0468943,19.7092527 27.1397667,19.7092527 C30.8208305,19.7092527 32.5095255,17.191077 32.7117879,13.501077",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "38.9689241 24.0827892 32.7116759 24.0827892 32.7116759 0.55432973 38.9655624 0.55432973 38.9655624 20.9296676"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 0.500642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24610993,0.0537986486 L6.24610993,24.616123 C6.24610993,25.3397176 6.286869,25.384 5.68115234,26.1624878 C5.07543569,26.9409756 4.13241485,26.8216237 3.56652832,26.8216237 C2.9591808,26.8216237 1.80997538,25.7581472 1.34082031,26.1624878 C0.871665247,26.5668285 0.860717773,26.7198596 0.860717773,27.1431569 C0.860717773,28.2490488 1.44906738,29.2009203 2.34608156,29.9311635 C3.24421631,30.6614068 5.39055674,31.0270824 6.78510284,31.0270824 C8.59369858,31.0270824 9.95742908,30.4807851 10.875734,29.3881905 C11.794039,28.2955959 12.2534716,26.6772041 12.2534716,24.534123 L12.2534716,0.0792851351 C12.2534716,0.0654337838 12.2417057,0.0537986486 12.2276986,0.0537986486 L6.24610993,0.0537986486 Z",
    id: "Fill-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.9586631,0.554606757 C76.5554433,0.554606757 81.9033511,5.8430527 81.9033511,12.3664851 C81.9033511,18.8899176 76.5554433,24.1789176 69.9586631,24.1789176 C63.3613227,24.1789176 58.0134149,18.8899176 58.0134149,12.3664851 C58.0134149,5.8430527 63.3613227,0.554606757 69.9586631,0.554606757 Z M72.7635226,5.62510965 C71.2139352,3.29315391 69.4615807,3.107971 67.6391568,3.57828655 C65.8173529,4.04798892 64.3800006,5.05607075 64.1797138,7.8393332 C64.0761599,9.27726015 64.5182791,12.006562 64.9548175,13.6609445 C65.3907358,15.315327 66.3537247,17.9097274 67.1542519,19.1152559 C68.7038393,21.4465984 70.4555737,21.6317814 72.2786177,21.162079 C74.1004215,20.6917634 75.5371538,19.6836816 75.7380607,16.9004192 C75.8416146,15.4624922 75.3994954,12.7331903 74.962957,11.0788079 C74.5264185,9.42442538 73.5640497,6.83002498 72.7635226,5.62510965 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.2,
    cy: 4,
    r: 4
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0acc37d1445e490e496e629de88b7177.svg";
export { ForwardRef as ReactComponent };